import React from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';

type ContentLineProps = {
  span: number;
  label: string;
  value: string | number;
  labelSpan?: number;
};

const ContentLine = ({ span, label, value, labelSpan = 8 }: ContentLineProps) => {
  return (
    <Col span={span}>
      <Row gutter={4}>
        <Col span={labelSpan}>
          <LabelStyled>{label}</LabelStyled>
        </Col>
        <Col>
          <ValueStyled>{value}</ValueStyled>
        </Col>
      </Row>
    </Col>
  );
};

export default ContentLine;



const LabelStyled = styled.div`
  color: #64748b;
  font-size: 1.3125em;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const ValueStyled = styled.div`
  color: #1d2129;
  font-size: 1.5em;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
